import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NewAnalysesComponent } from './new-analyses.component';

const routes: Routes = [{
  path: '',
  component: NewAnalysesComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewAnalysesRoutingModule { }
